// Infants (under 2) children (2 and above)
const isNotInfant = (age: number) => age >= 2;

const childrenNotInfants = (childAges: number[] | number) => {
  if (!Array.isArray(childAges)) {
    return childAges;
  }
  return childAges.filter((age) => isNotInfant(age)).length;
};

// infants travel free
const chargeableChildren = (childAges: number[] | number) => {
  const payingChildren: number[] = [];
  const nonPayingInfants: number[] = [];

  // legacy support where we only have child_count
  if (!Array.isArray(childAges)) {
    return {
      payingChildren: childAges,
      nonPayingInfants: 0
    };
  }

  childAges.filter((age) => (isNotInfant(age) ? payingChildren.push(age) : nonPayingInfants.push(age)));
  return {
    payingChildren: payingChildren.length,
    nonPayingInfants: nonPayingInfants.length
  };
};

// Infants do not contribute to room occupancy
const minNumberRooms = (numberAdults: number, childAges: number[] | number) => {
  return Math.max(Math.ceil(numberAdults / 2), Math.ceil((numberAdults + childrenNotInfants(childAges)) / 4));
};

// Infants not included in per person calulation
const pricePerPerson = (total: number, numberAdults: number, children: number[] | number) => {
  const { payingChildren } = chargeableChildren(children);
  return Math.ceil(total / (numberAdults + payingChildren));
};

const aggregatePax = (travellerMixes: { adultCount: number; childAges: number[] }[]) => ({
  adultCount: travellerMixes.reduce((sum, mix) => sum + mix.adultCount, 0) || 2,
  childAges: travellerMixes.flatMap((mix) => mix.childAges)
});

// Only need ages for quote and check
const paxAges = (numberAdults: number, childAges: number[] | number) => {
  const ages: { age: number }[] = [];
  for (let i = 0; i < numberAdults; i++) {
    ages.push({ age: 30 });
  }
  if (Array.isArray(childAges)) {
    for (let i = 0; i < childAges.length; i++) {
      ages.push({ age: childAges[i] });
    }
  } else {
    // legacy support where childAges not provided
    for (let i = 0; i < childAges; i++) {
      ages.push({ age: 12 });
    }
  }
  return ages;
};

const getRoomCount = (pinnedRoomsInHotel: { [key: string]: any[] } | null) => {
  if (!pinnedRoomsInHotel) return 1;
  const hotelRooms = Object.values(pinnedRoomsInHotel)[0];
  return Array.isArray(hotelRooms) ? hotelRooms.length : 1;
};

export { aggregatePax, chargeableChildren, minNumberRooms, paxAges, pricePerPerson, getRoomCount };
